import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=1c4cf304"
import script from "./Barrage.vue?vue&type=script&lang=js"
export * from "./Barrage.vue?vue&type=script&lang=js"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=1c4cf304&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports